import { SHOW_AWARD, HIDE_AWARD, HIDE_BACKGROUND_OF_AWARD, SET_CURRENT_CARD } from '../types/award';

export const showAward = () => ({ type: SHOW_AWARD });
export const hideAward = () => ({ type: HIDE_AWARD });
export const hideBackgroundOfAward = () => ({ type: HIDE_BACKGROUND_OF_AWARD });
export const setCurrentCard = data => ({ type: SET_CURRENT_CARD, payload: data });
